import React from 'react';

const PagePageNotFound = () => {
    return (
        <div className="flex justify-center items-center flex-col h-screen ">
            <h1 className="sm:text-2xl md:text-4xl lg:text-6xl border-b border-b-black">404 ERROR</h1>
            <h3 className="sm:text-xl md:text-2xl lg:text-4xl mt-2">Page Not Found</h3>
        </div>
    )
}

export default PagePageNotFound;
